export class clsUser {
  login: boolean;
  name: string;
  email: string;
  admin_flg: boolean;
  csrf: string;
  validmail: boolean;
  constructor() {
    this.login = false;
    this.name = '';
    this.email = '';
    this.admin_flg = false;
    this.csrf = '';
    this.validmail = false;
  }
  clear(): void {
    this.login = false;
    this.name = '';
    this.email = '';
    this.admin_flg = false;
    this.csrf = '';
    this.validmail = false;
  }
}